/**
 * @typedef {import('./types/fsui').SurchargeEnrollmentStatus} SurchargeEnrollmentStatus
 */

/**
 * @type {{
 *   NotSet: SurchargeEnrollmentStatus.NotSet
 *   Enrolled: SurchargeEnrollmentStatus.Enrolled
 *   Prohibited: SurchargeEnrollmentStatus.Prohibited
 *   OptedOut: SurchargeEnrollmentStatus.OptedOut
 * }}
 */
export const SURCHARGE_ENROLLMENT_STATUS = {
  NotSet: 'NotSet',
  Enrolled: 'Enrolled',
  Prohibited: 'Prohibited',
  OptedOut: 'OptedOut',
};
